import { unsafeCSS } from 'lit'
import { property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../internal/dds-hu-element'
import styles from './table-header.scss?inline'

/**
 * Table header cell component.
 * @element dap-ds-table-header
 * @title - Table header
 * @group table
 *
 * @slot - The default slot.
 *
 * @csspart base - The main header cell container.
 *
 * @cssproperty --dds-table-header-padding-block - Padding for the top and bottom of the header cell. (default: var(--dds-spacing-200))
 * @cssproperty --dds-table-header-padding-inline-start - Padding for the start (left in LTR) of the header cell. (default: var(--dds-spacing-500))
 * @cssproperty --dds-table-header-padding-inline-end - Padding for the end (right in LTR) of the header cell. (default: var(--dds-spacing-200))
 * @cssproperty --dds-table-header-border-width - Width of the header cell's bottom border. (default: var(--dds-border-width-base))
 * @cssproperty --dds-table-header-border-color - Color of the header cell's bottom border. (default: var(--dds-border-neutral-subtle))
 * @cssproperty --dds-table-header-text-color - Text color of the header cell. (default: var(--dds-text-neutral-strong))
 * @cssproperty --dds-table-header-font-weight - Font weight of the header cell text. (default: var(--dds-font-weight-bold))
 * @cssproperty --dds-table-header-line-height - Line height of the header cell text. (default: var(--dds-font-line-height-xlarge))
 */
export default class DapDSTableHeader extends DdsElement {
  static tagName = 'dap-ds-table-header'

  static readonly styles = unsafeCSS(styles)

  /**If the header cell is the last one.*/
  @property({ type: Boolean, reflect: true }) last: boolean
  /** The html role of the header cell */
  @property({ reflect: true })
  public role = 'columnheader'

  render() {
    return html` <slot part="base"></slot> `
  }
}
